import * as accountApi from '../../api/accounts-api';
import * as accountsApi from '../../api/accounts-api';
import { IAccountBillTo } from '../../models/account';
import { IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';
import { IAccount, ISessionAccount } from '../../models/company-account';

export const LOAD_BILL_TO_ACCOUNTS_SUCCESS = 'LOAD_BILL_TO_ACCOUNTS_SUCCESS';
export const LOAD_BILL_TO_ACCOUNTS_ERROR = 'LOAD_BILL_TO_ACCOUNTS_ERROR';
export const LOAD_SHIP_TO_ACCOUNTS_SUCCESS = 'LOAD_SHIP_TO_ACCOUNTS_SUCCESS';
export const LOAD_SHIP_TO_ACCOUNTS_ERROR = 'LOAD_SHIP_TO_ACCOUNTS_ERROR';
export const LOAD_SESSION_ACCOUNT_SUCCESS = 'LOAD_SESSION_ACCOUNT_SUCCESS';
export const LOAD_SESSION_ACCOUNT_ERROR = 'LOAD_SESSION_ACCOUNT_ERROR';
export const loadBillToAccountsSuccess = (
    result: IResult<IAccountBillTo[]>
) => ({
    type: LOAD_BILL_TO_ACCOUNTS_SUCCESS,
    result,
});

export const loadShipToAccountsSuccess = (payload: IResult<IAccount[]>) => ({
    type: LOAD_SHIP_TO_ACCOUNTS_SUCCESS,
    payload,
});

export const loadSessionAccountSuccess = (payload: IResult<IAccount>) => ({
    type: LOAD_SESSION_ACCOUNT_SUCCESS,
    payload,
});

// Thunks
export const loadBillToAccounts = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall('LOAD_BILL_TO_ACCOUNTS'));
            const result = await accountsApi.getBillToAccounts();
            dispatch(loadBillToAccountsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const loadShipToAccounts = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall('LOAD_SHIP_TO_ACCOUNTS'));
            const result = await accountApi.getShipToAccounts();
            dispatch(loadShipToAccountsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const loadSessionAccount = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall('LOAD_SESSION_ACCOUNT'));
            const result = await accountApi.getSessionAccount();
            dispatch(loadSessionAccountSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
